import React from 'react';
import { Paper, Group, Text, Badge, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { DeviceConfig } from '../../types/devices';

interface DeviceCardProps {
  device: DeviceConfig;
  onClick: () => void;
}

export const DeviceCard: React.FC<DeviceCardProps> = ({ device, onClick }) => {
  return (
    <UnstyledButton onClick={onClick} w="100%">
      <Paper withBorder p="md" radius="md">
        <Group justify="space-between" wrap="nowrap">
          <Text fw={500} truncate style={{ flex: 1 }}>
            {device.display_name}
          </Text>
          <Group gap="xs" wrap="nowrap">
            <Badge color={device.is_enabled ? 'green' : 'gray'} size="sm">
              {device.is_enabled ? 'Enabled' : 'Disabled'}
            </Badge>
            <IconChevronRight size={16} color="gray" />
          </Group>
        </Group>
      </Paper>
    </UnstyledButton>
  );
};
